import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './yetkisiz-kullanici.component.html',
  styles: [
  ]
})
export class YetkisizKullaniciComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
